// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__CLYHD","navbar__title":"Navbar_navbar__title__c2XG8","navbar__item":"Navbar_navbar__item__2vBhl","links":"Navbar_links__2x1pm"};